import { render } from "./HeroItemContainer.vue?vue&type=template&id=242b61ac"
import script from "./HeroItemContainer.vue?vue&type=script&lang=js"
export * from "./HeroItemContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/elements/HeroItemContainer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "242b61ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('242b61ac', __exports__)) {
    api.reload('242b61ac', __exports__)
  }
  
  module.hot.accept("./HeroItemContainer.vue?vue&type=template&id=242b61ac", () => {
    api.rerender('242b61ac', render)
  })

}


export default __exports__